


























import { defineComponent } from "@vue/composition-api";
import OccHeading from "@/components/Atoms/OccHeading/index.vue";

export default defineComponent({
  name: "PageHeader",
  emits: ["mouseover", "mouseleave"],
  components: {
    OccHeading
  },
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: undefined
    }
  },
  setup(_, { emit }) {
    const handleMouseOver = () => {
      emit("mouseover");
    };

    const handleMouseLeave = () => {
      emit("mouseleave");
    };

    return {
      handleMouseOver,
      handleMouseLeave
    };
  }
});
